import { useEffect, useRef, useState } from "react";
import { getUniqueFileName } from "../helpers/creditBonus/helper";

export function useMerchForm(item, DEFAULT_FORM, REQUIRED = []) {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [previews, setPreviews] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [disableBtn, setDisableBtn] = useState(true);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // setForm((prev) => ({ ...prev, [name]: value }));
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setFieldErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleFiles = (e) => {
    const selected = Array.from(e.target.files);
    const currentAssets = [...form.assets];

    const entries = selected.map((file) => {
      const safeName = getUniqueFileName(file.name, currentAssets);
      currentAssets.push({ fileName: safeName });
      return { file, fileName: safeName };
    });

    setForm((prev) => ({
      ...prev,
      assets: [...prev.assets, ...entries],
    }));
    setPreviews((prev) => [
      ...prev,
      ...entries.map((entry) => ({
        fileName: entry.fileName,
        objectUrl: URL.createObjectURL(entry.file),
      })),
    ]);

    e.target.value = "";
  };

  const removeFile = (fileName) => {
    setForm((prev) => ({
      ...prev,
      assets: prev.assets.filter((f) => f.fileName !== fileName),
    }));
    setPreviews((prev) => {
      const removed = prev.find((p) => p.fileName === fileName);
      if (removed) URL.revokeObjectURL(removed.objectUrl);
      return prev.filter((p) => p.fileName !== fileName);
    });
  };

  const reset = () => {
    setForm(DEFAULT_FORM);
    setPreviews([]);
  };

  useEffect(() => {
    setDisableBtn(REQUIRED.some((k) => !form[k]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return {
    form,
    previews,
    fieldErrors,
    disableBtn,
    fileInputRef,
    handleChange,
    handleFiles,
    removeFile,
    reset,
    setForm,
    setPreviews,
  };
}
